import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ef88851"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ef88851')) {
      api.createRecord('0ef88851', component.options)
    } else {
      api.reload('0ef88851', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0ef88851", function () {
      api.rerender('0ef88851', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalFooter/index.vue"
export default component.exports